import React from 'react';

const RedoIcon = (svg: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...svg}
    width="24"
    className="stroke-[#26272B] transition-all duration-300 group-hover:stroke-primary-500"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.8701 18.3101H8.87012C6.11012 18.3101 3.87012 16.0701 3.87012 13.3101C3.87012 10.5501 6.11012 8.31006 8.87012 8.31006H19.8701"
      stroke="current"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5701 10.8099L20.1301 8.24994L17.5701 5.68994"
      stroke="current"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RedoIcon;
